import React, { useEffect, useMemo, useState } from 'react';
import { parseAssetSource } from '../../utils/asset';
import { LinkAnalyzer } from '../../services/link-analyzer';
import { blokToComponent } from '../../helpers/blok-to-component';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheTeaser } from '../../types/global';

type RocheTeaserProps = BlokToComponentProps<
  RocheTeaser & {
    page: string;
    teaser_image: { brightcove_id?: string; src?: { filename: string } }[];
    teaser_description: string;
    teaser_overline: string;
    teaser_title: string;
    slotted_secondary_action: any[];
  }
>;

export const RocheTeaserExternal = ({
  blok: {
    teaser_image: teaserImage = [],
    teaser_description: teaserDescription,
    layout,
    teaser_overline: teaserOverline,
    teaser_title: teaserTitle,
    page,
    slotted_secondary_action: slotted = [],
  },
  slot,
  getComponent,
}: RocheTeaserProps): JSX.Element => {
  const firstTeaserImage = teaserImage?.[0];

  const [state, setState] = useState({
    internalLinkUrl: '',
    isExternalLink: false,
    loaded: false,
  });

  useEffect(() => {
    const { internalLinkUrl, isExternalLink } = LinkAnalyzer.analyzeLink(page);
    setState({
      internalLinkUrl,
      isExternalLink,
      loaded: state.loaded,
    });
  }, [page]);

  useEffect(() => {
    if (firstTeaserImage && teaserTitle && page) {
      setState((prevState) => ({
        ...prevState,
        loaded: true,
      }));
    }
  }, [firstTeaserImage, teaserTitle, page]);

  const slottedComponents = useMemo(
    () =>
      slotted.map((component) => {
        if (component.component === 'roche-button') {
          return {
            ...component,
            appearance: 'tertiary',
          };
        } else {
          return {}; // in schema slotted is set to a maximum of 1 child (of type button)
        }
      }),
    [slotted, layout],
  );

  return (
    <roche-teaser
      layout={layout}
      teaser-title={teaserTitle}
      teaser-overline={teaserOverline}
      teaser-description={teaserDescription}
      teaser-image={firstTeaserImage?.brightcove_id || parseAssetSource(firstTeaserImage?.src?.filename)}
      teaser-url={state.internalLinkUrl || `${page}`}
      loaded={state.loaded}
      is-external-link={state.isExternalLink}
      slot={slot}
    >
      {slottedComponents?.map((component) => {
        return blokToComponent(
          {
            getComponent,
            blok: component,
            slot: 'secondary-action',
          },
          `button`,
        );
      })}
      <a href={state.internalLinkUrl || `${page}`}>{teaserTitle}</a>
    </roche-teaser>
  );
};
